<cbc-navbar class="mat-elevation-z6"></cbc-navbar>
<router-outlet></router-outlet>
